import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export default function AuthLoading({ label = 'Laden…' }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'var(--bg-secondary, #f8f9fa)',
        color: 'var(--text-primary, #1a1a1a)',
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" sx={{ fontWeight: 500, opacity: 0.7 }}>
        {label}
      </Typography>
    </Box>
  );
}
